module.exports = __webpack_public_path__ + "img/auto_map_new.e2fee768.jpg";